import React, { useState } from 'react';
import { Card, Row, Col, Button, Badge, Modal, Form, Table } from 'react-bootstrap';
import {
    LuLifeBuoy, LuMail, LuMessageSquare, LuPhone,
    LuPlus, LuTicket, LuImage, LuSend, LuHistory
} from "react-icons/lu";

const Support = () => {
    const [showTicketModal, setShowTicketModal] = useState(false);
    const [attachment, setAttachment] = useState(null);

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setAttachment(e.target.files[0].name);
        }
    };

    return (
        <div className="support-page p-3 p-md-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h3 className="fw-bold text-brand">Support Center</h3>
                    <p className="text-muted small">Need help? Get in touch or track your active tickets.</p>
                </div>
                <Button
                    variant="brand"
                    className="rounded-pill px-4 shadow-sm d-flex align-items-center gap-2"
                    onClick={() => setShowTicketModal(true)}
                >
                    <LuPlus size={18} /> Raise a Ticket
                </Button>
            </div>

            <Row className="g-4">
                {/* Contact Information Cards */}
                <Col lg={4}>
                    <Card className="border-0 shadow-sm rounded-4 p-4 h-100">
                        <h5 className="fw-bold mb-4">Get in Touch</h5>

                        <div className="d-flex align-items-center gap-3 mb-4">
                            <div className="bg-soft-brand p-3 rounded-circle text-brand">
                                <LuMail size={22} />
                            </div>
                            <div>
                                <p className="mb-0 fw-bold small">Email Support</p>
                                <small className="text-muted">mailtoseventech@gmail.com</small>
                            </div>
                        </div>

                        <div className="d-flex align-items-center gap-3 mb-4">
                            <div className="bg-soft-brand p-3 rounded-circle text-brand">
                                <LuMessageSquare size={22} />
                            </div>
                            <div>
                                <p className="mb-0 fw-bold small">WhatsApp Chat</p>
                                <small className="text-muted">+1 (437) 410-3477</small>
                            </div>
                        </div>

                        <div className="d-flex align-items-center gap-3">
                            <div className="bg-soft-brand p-3 rounded-circle text-brand">
                                <LuPhone size={22} />
                            </div>
                            <div>
                                <p className="mb-0 fw-bold small">Priority Call</p>
                                <small className="text-muted">Available 9am - 6pm EST</small>
                            </div>
                        </div>

                        <hr className="my-4 opacity-50" />

                        <div className="bg-light p-3 rounded-4">
                            <p className="small fw-bold mb-1">Response Time</p>
                            <small className="text-muted d-block">Average response time is currently <strong>~2 hours</strong>.</small>
                        </div>
                    </Card>
                </Col>

                {/* Ticket History */}
                <Col lg={8}>
                    <Card className="border-0 shadow-sm rounded-4 p-4 h-100">
                        {/* <div className="d-flex align-items-center gap-2 mb-4">
                            <LuHistory className="text-muted" />
                            <h5 className="fw-bold mb-0">Recent Tickets</h5>
                        </div> */}
                        <p>You can't raise Support Ticket on free tier. Please use email service.</p>
                        {/* <Table responsive borderless className="align-middle">
                            <thead className="text-muted small border-bottom">
                                <tr>
                                    <th className="pb-3">Ticket ID</th>
                                    <th className="pb-3">Subject</th>
                                    <th className="pb-3">Status</th>
                                    <th className="pb-3">Last Update</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="border-bottom-light">
                                    <td className="fw-bold small">#SB-9920</td>
                                    <td className="small">Billing issue with annual plan</td>
                                    <td><Badge bg="warning" className="fw-medium">In Progress</Badge></td>
                                    <td className="text-muted small">2 hours ago</td>
                                </tr>
                                <tr className="border-bottom-light">
                                    <td className="fw-bold small">#SB-8812</td>
                                    <td className="small">Cannot sync Google Calendar</td>
                                    <td><Badge bg="success" className="fw-medium">Resolved</Badge></td>
                                    <td className="text-muted small">Yesterday</td>
                                </tr>
                            </tbody>
                        </Table> */}
                    </Card>
                </Col>
            </Row>

            {/* CREATE TICKET MODAL */}
            <Modal show={showTicketModal} onHide={() => setShowTicketModal(false)} centered borderless>
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold d-flex align-items-center gap-2">
                        <LuTicket className="text-brand" /> New Support Ticket
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-4">
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Issue Subject</Form.Label>
                            <Form.Control type="text" placeholder="Briefly describe the issue" className="bg-light border-0 py-2 shadow-none" />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Detailed Description</Form.Label>
                            <Form.Control as="textarea" rows={4} placeholder="Tell us exactly what happened..." className="bg-light border-0 shadow-none" />
                        </Form.Group>

                        {/* Image Upload Area */}
                        <Form.Group className="mb-2">
                            <Form.Label className="small fw-bold">Attach Screenshot</Form.Label>
                            <div className="border-dashed rounded-4 p-3 text-center bg-light">
                                <input type="file" id="ticket-img" hidden onChange={handleFileChange} />
                                <label htmlFor="ticket-img" className="cursor-pointer">
                                    <LuImage size={30} className="text-brand mb-2" />
                                    <p className="small mb-0 text-dark fw-bold">
                                        {attachment ? attachment : "Click to upload image"}
                                    </p>
                                    <small className="text-muted">PNG, JPG up to 5MB</small>
                                </label>
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <Button variant="light" className="rounded-pill px-4" onClick={() => setShowTicketModal(false)}>Cancel</Button>
                    <Button variant="brand" className="rounded-pill px-4 d-flex align-items-center gap-2" disabled>
                        <LuSend size={18} /> Submit Ticket
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Support;